import http from '@/http';
export default class InscricaoService {



	gerarResutadoSelecaoEstagio(idProcesso) {
		console.log('processo: ', idProcesso);
		return http.get(`inscricao/gerar-resultado/${idProcesso}`).then(res => res.data);
    }
	gerarResutadoSelecaoEstagioReservadas(idProcesso) {
		console.log('id processo: ', idProcesso);
		return http.get(`inscricao/gerar-resultado-reservadas/${idProcesso}`).then(res => res.data);
    }
	inserirNota(codInscricao,inscricao) {
		console.log('getIncricao: ', codInscricao);
		return http.put(`inscricao/nota/${codInscricao}`,inscricao).then(res => res.data);
    }

	getInscritosSalaExtra(idProcesso) {
		console.log('getIncricao: ', idProcesso);
		return http.get(`inscricao/inscricoes-sala-extra/${idProcesso}`).then(res => res.data);
    }

	findBySelecaoEstagioInscricaoSalaExtra(idProcesso) {
		console.log('getIncricao: ', idProcesso);
		return http.get(`inscricao/inscricoes-sala-extra-confirmada/${idProcesso}`).then(res => res.data);
    }

	getInscricaoAll() {
		console.log('getIncricao ...');
		return http.get('inscricao/todas').then(res => res.data);
    }

	getInscricaoByIdpr(idProcesso) {
		console.log('getIncricao: ', idProcesso);
		return http.get(`inscricao/selecao/${idProcesso}`).then(res => res.data);
    }

	getInscricaoDetalhadaById(identificador) {
		// console.log('getIncricao: ', idProcesso);
		return http.get(`inscricao/detalhada/${identificador}`).then(res => res.data);
    }

	getInscricaoByIdprocesso(idProcesso) {
		console.log('getIncricao: ', idProcesso);
		return http.get(`inscricao/lazy/${idProcesso}`).then(res => res.data);
    }

	findAllWithNotas(idProcesso) {
		console.log('getIncricao: ', idProcesso);
		return http.get(`inscricao/notas/${idProcesso}`).then(res => res.data);
    }


	getInscricaoById(idInscricao) {
		console.log('getIncricao: ', idInscricao);
		return http.get(`inscricao/${idInscricao}`).then(res => res.data);
    }

	getInscricaoByUsuarioBySelecaoEmAndamento(idUsuario) {
		return http.get(`inscricao/usuario/${idUsuario}/emAndamento`).then(res => res.data);
    }

	getInscricaoByUsuarioBySelecaoFinalizadas(idUsuario) {
		return http.get(`inscricao/usuario/${idUsuario}/anteriores`).then(res => res.data);
    }

	getInscricaoByUsuario(idUsuario) {
		return http.get(`inscricao/usuario/${idUsuario}`).then(res => res.data);
    }

	getQtCandidatos(salaId) {
		return http.get(`inscricao/qt-inscritos-sala/${salaId}`).then(res => res.data);
    }

	findFirstBySalaId(salaId) {
		return http.get(`inscricao/first-inscricao-sala/${salaId}`).then(res => res.data);
    }

	getInscricaoSala(salaId) {
		return http.get(`inscricao/sala/${salaId}`).then(res => res.data);
    }

	update(inscricao) {
		let inscricaoToUpdate = {
			coefic_red_escolar: inscricao.coefic_red_escolar,
			estado: inscricao.estadoInscricao.cod,
			mensagem: inscricao.mensagem,
			salaExtra: inscricao.salaExtra=='Sim' ? true : false,
			atendimento_especial: inscricao.atendimento_especial,
			concorre_vagas_reservadas: inscricao.concorreVagasReservadas,
			username: inscricao.username,
			horasCursadas: inscricao.horasCursadas,
			isentoPagamento: inscricao.isentoPagamento
		}
		// console.log('inscricaoToUpdate: ', JSON.stringify(inscricaoToUpdate));
		return http.put(`inscricao/${inscricao.identificador}`, inscricaoToUpdate).then(res => res.data);
	}

	countTotalInscricoesByEstado(idProcesso) {
		return http.get(`/inscricao/count-estado-inscricao/${idProcesso}`).then(res => res.data);
    }

	countAreaAmpla(idProcesso) {
		return http.get(`/inscricao/count-area-ampla/${idProcesso}`).then(res => res.data);
    }

	countAreaDeficientes(idProcesso) {
		return http.get(`/inscricao/count-area-reservada/${idProcesso}`).then(res => res.data);
    }

	countTotalInscricoesByInstituicao(idProcesso) {
		return http.get(`/inscricao/count-instituicao-inscricao/${idProcesso}`).then(res => res.data);
    }

	getPendenciasDistribuicao(idProcesso) {
		return http.get(`inscricao/distribuicao/pendencias/${idProcesso}`).then(res => res.data);
    }

	postUpdateDocumentosInscricao(idInscricao, fd) {
		return http.put(`inscricao/update/documentos/${idInscricao}`, fd).then(res => res.data);
	}

	exportar(identificador, tituloArquivo) {
		console.log("identificador: ", identificador);

		var url = `inscricao/exportar-resultado/${identificador}`;

		return	http({
			url: url,
			method: "GET",
			responseType: "blob",
			 headers: {
				  'Content-Type': 'octet-stream;charset=UTF-8',
				  'Accept': 'application/pdf'
			  }
		  }).then((reponse) => {
			console.log("identificador: ", reponse);

		  const fileBlob = new Blob([reponse.data]);

		  const fileUrl = window.URL.createObjectURL(fileBlob);

		  const fileLink = document.createElement("a");
		  fileLink.href = fileUrl;


		  fileLink.setAttribute(
			"download",
			`${tituloArquivo}.pdf`
		  );
		  fileLink.setAttribute("target", "_blank");

		  document.body.appendChild(fileLink);

		  fileLink.click();
		});
	  }

	  exportarParaAssinar(identificador, tituloArquivo) {
		console.log("identificador: ", identificador);

		var url = `inscricao/exportar-assinatura/${identificador}`;

		return http({
			url: url,
			method: "GET",
			responseType: "blob",
			 headers: {
				  'Content-Type': 'octet-stream;charset=UTF-8',
				  'Accept': 'application/pdf'
			  }
		  }).then((reponse) => {
			console.log("identificador: ", reponse);

		  const fileBlob = new Blob([reponse.data]);

		  const fileUrl = window.URL.createObjectURL(fileBlob);

		  const fileLink = document.createElement("a");
		  fileLink.href = fileUrl;


		  fileLink.setAttribute(
			"download",
			`${tituloArquivo}.pdf`
		  );
		  fileLink.setAttribute("target", "_blank");

		  document.body.appendChild(fileLink);

		  fileLink.click();
		});
	  }

	exportarInscricoesCSV(selecaoId, tituloArquivo) {
		var url = `inscricao/exportar/inscricoes/${selecaoId}`;

	// 	return http({url: url,
	// 			method: "GET",
	// 			responseType: "blob",
	// 			headers: { 'Content-Type': 'text/plain;charset=UTF-8',}
	// 	}).then((reponse) => {
	// 		const fileBlob = new Blob([reponse.data]);
	// 		const fileUrl = window.URL.createObjectURL(fileBlob);
	// 		const fileLink = document.createElement("a");
	// 		fileLink.href = fileUrl;

	// 		fileLink.setAttribute("download",`${tituloArquivo}.csv`);
	// 		fileLink.setAttribute("target", "_blank");

	// 		document.body.appendChild(fileLink);

	// 		fileLink.click();
	// 	});
	// }
//
	// exportarInscricoesPlanilha(selecaoId, tituloArquivo) {
	// 	var url = `inscricao/exportar/inscricoes/planilha/${selecaoId}`;

		return http({
			url: url,
			method: "GET",
			responseType: "blob",
			headers: {
				"Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			}
		}).then((reponse) => {
			const fileBlob = new Blob([reponse.data], {
				type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
			});

			const fileUrl = window.URL.createObjectURL(fileBlob);
			const fileLink = document.createElement("a");
			fileLink.href = fileUrl;

			fileLink.setAttribute("download", `${tituloArquivo}.xlsx`);
			fileLink.setAttribute("target", "_blank");

			document.body.appendChild(fileLink);
			fileLink.click();

			document.body.removeChild(fileLink);
			window.URL.revokeObjectURL(fileUrl);
		});
	}


	getListaIntituicoes() {
		return http.get(`inscricao/lista/instituicaoEnsino`).then(res => res.data);
    }

	exportarInscricoesNotaCSV(selecaoId, tituloArquivo) {
		var url = `inscricao/exportar/inscricoes/nota/${selecaoId}`;

		this.exportarBase(url, tituloArquivo);
	}

	exportarBase(url, tituloArquivo) {

		return http({url: url,
				method: "GET",
				responseType: "blob",
				headers: { 'Content-Type': 'text/plain;charset=UTF-8',}})
			.then((reponse) => {
				const fileBlob = new Blob([reponse.data]);
				const fileUrl = window.URL.createObjectURL(fileBlob);
				const fileLink = document.createElement("a");
				fileLink.href = fileUrl;

				fileLink.setAttribute("download",`${tituloArquivo}.csv`);
				fileLink.setAttribute("target", "_blank");

				document.body.appendChild(fileLink);

				fileLink.click();
			});
	}
}
